import { render, staticRenderFns } from "./schoolDetails.vue?vue&type=template&id=1ada2099&scoped=true"
import script from "./schoolDetails.vue?vue&type=script&lang=js"
export * from "./schoolDetails.vue?vue&type=script&lang=js"
import style0 from "./schoolDetails.vue?vue&type=style&index=0&id=1ada2099&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada2099",
  null
  
)

export default component.exports